import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=061c38c6&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=js&"
export * from "./LicenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c38c6",
  null
  
)

export default component.exports